const skeletonComponent = `
    <div>
        <div class="searched-term-detail skeleton">
            <div class="mobile-result-counter">
            </div>
        </div>
        <div class="toolbar">
            <div class="filter-toggle skeleton">
                <button type="button" class="filter-toggle__button">
                    <span class="skeleton__65"></span>
                    <div class="rotate">
                        <svg style="transform: rotate(180deg);" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 7L7 0.999999L1 7" stroke="#404040" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </div>
                </button>
            </div>
            <div class="view skeleton">
                <div class="view__label skeleton__75px"></div>
                <div class="view__options">
                    <button type="button" class="view__trigger view__trigger--mobile">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve">
                            <style type="text/css">
                                .st0{fill:none;stroke:#404040;}
                            </style>
                            <rect x="0.5" y="0.5" class="st0" width="24" height="24"></rect>
                        </svg>
                    </button>
                    <button type="button" class="view__trigger view__trigger--mobile">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" stroke="#404040" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="11" height="11" stroke="#404040"></rect>
                            <rect x="13.5" y="0.5" width="11" height="11" stroke="#404040"></rect>
                            <rect x="0.5" y="13.5" width="11" height="11" stroke="#404040"></rect>
                            <rect x="13.5" y="13.5" width="11" height="11" stroke="#404040"></rect>
                        </svg>
                    </button>
                    <button type="button" class="view__trigger view__trigger--desktop">
                        <svg width="31" height="21" viewBox="0 0 31 21" fill="none" stroke="#404040" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="13" height="20" stroke="#404040"></rect>
                            <rect x="17.5" y="0.5" width="13" height="20" stroke="#404040"></rect>
                        </svg>
                    </button>
                    <button type="button" class="view__trigger view__trigger--desktop">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 34 21" style="enable-background:new 0 0 34 21;" xml:space="preserve">
                            <style type="text/css">
                                .st0{fill:none;stroke:#404040;}
                            </style>
                            <rect x="0.5" y="0.5" class="st0" width="6" height="8"></rect>
                            <rect x="9.5" y="0.5" class="st0" width="6" height="8"></rect>
                            <rect x="18.5" y="0.5" class="st0" width="6" height="8"></rect>
                            <rect x="27.5" y="0.5" class="st0" width="6" height="8"></rect>
                            <rect x="0.5" y="12.5" class="st0" width="6" height="8"></rect>
                            <rect x="9.5" y="12.5" class="st0" width="6" height="8"></rect>
                            <rect x="18.5" y="12.5" class="st0" width="6" height="8"></rect>
                            <rect x="27.5" y="12.5" class="st0" width="6" height="8"></rect>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="products__wrapper">
            <div class="filters">
                <div class="filters__content">
                    <div class="filters__content-body">
                        <div class="filters_count skeleton">
                            <div class="skeleton__65"></div>
                        </div>
                        <div class="filters__block skeleton">
                            <div class="filter__trigger">
                            <div class="skeleton__65"></div>
                                <span class="filter__icon">
                                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </span>
                            </div>
                        </div>
                        <div class="filters__block skeleton">
                            <div class="filter__trigger">
                            <div class="skeleton__65"></div>
                                <span class="filter__icon">
                                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </span>
                            </div>
                        </div>
                        <div class="filters__block skeleton">
                            <div class="filter__trigger">
                            <div class="skeleton__65"></div>
                                <span class="filter__icon">
                                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </span>
                            </div>
                        </div>
                        <div class="filters__block skeleton">
                            <div class="filter__trigger">
                            <div class="skeleton__65"></div>
                                <span class="filter__icon">
                                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </span>
                            </div>
                        </div>
                        <div class="filters__block skeleton">
                            <div class="filter__trigger">
                            <div class="skeleton__65"></div>
                                <span class="filter__icon">
                                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </span>
                            </div>
                        </div>
                        <div class="filters__block skeleton">
                            <div class="filter__trigger">
                            <div class="skeleton__65"></div>
                                <span class="filter__icon">
                                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </span>
                            </div>
                        </div>
                        <div class="filters__block skeleton">
                            <div class="filter__trigger">
                            <div class="skeleton__65"></div>
                                <span class="filter__icon">
                                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </span>
                            </div>
                        </div>
                        <div class="filters__block skeleton">
                            <div class="filter__trigger">
                            <div class="skeleton__65"></div>
                                <span class="filter__icon">
                                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="products" data-column-grid="skeleton">
              <div class="product prod-card is-loading">
                <figure class="prod-card__media-container"></figure>
                <header class="prod-card__header">
                  <div class="prod-card__details">
                    <span class="prod-card__title"></span>
                    <span class="prod-card__prices"></span>
                  </div>
                </header>
              </div>
              <div class="product prod-card is-loading">
                <figure class="prod-card__media-container"></figure>
                <header class="prod-card__header">
                  <div class="prod-card__details">
                    <span class="prod-card__title"></span>
                    <span class="prod-card__prices"></span>
                  </div>
                </header>
              </div>
              <div class="product prod-card is-loading">
                <figure class="prod-card__media-container"></figure>
                <header class="prod-card__header">
                  <div class="prod-card__details">
                    <span class="prod-card__title"></span>
                    <span class="prod-card__prices"></span>
                  </div>
                </header>
              </div>
              <div class="product prod-card is-loading">
                <figure class="prod-card__media-container"></figure>
                <header class="prod-card__header">
                  <div class="prod-card__details">
                    <span class="prod-card__title"></span>
                    <span class="prod-card__prices"></span>
                  </div>
                </header>
              </div>
              <div class="product prod-card is-loading">
                <figure class="prod-card__media-container"></figure>
                <header class="prod-card__header">
                  <div class="prod-card__details">
                    <span class="prod-card__title"></span>
                    <span class="prod-card__prices"></span>
                  </div>
                </header>
              </div>
              <div class="product prod-card is-loading">
                <figure class="prod-card__media-container"></figure>
                <header class="prod-card__header">
                  <div class="prod-card__details">
                    <span class="prod-card__title"></span>
                    <span class="prod-card__prices"></span>
                  </div>
                </header>
              </div>
              <div class="product prod-card is-loading">
                <figure class="prod-card__media-container"></figure>
                <header class="prod-card__header">
                  <div class="prod-card__details">
                    <span class="prod-card__title"></span>
                    <span class="prod-card__prices"></span>
                  </div>
                </header>
              </div>
              <div class="product prod-card is-loading">
                <figure class="prod-card__media-container"></figure>
                <header class="prod-card__header">
                  <div class="prod-card__details">
                    <span class="prod-card__title"></span>
                    <span class="prod-card__prices"></span>
                  </div>
                </header>
              </div>
            </div>
        </div>
    </div>`;
export default skeletonComponent;
